import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SelectContactsPage } from './select-contacts.page';

const routes: Routes = [
  {
    path: '',
    component: SelectContactsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelectContactsPageRoutingModule {}
